import React from 'react';
import { useSelector } from 'react-redux';
import LoadingComponent from '../shared/loading/LoadingComponent';

export default function GlobalLoadingComponent() {
  const commonStateLoading = useSelector((state) => state.commonState.loading);
  return <LoadingComponent open={commonStateLoading} description />;
}
